// @flow

import React from 'react';
import bemify from 'bemify-js';

import { StaticImage } from '@zapier/common-components';

import SimplePromo from 'app/login/components/SimplePromo';
import 'app/login/components/PlatformLogin/PlatformLogin.scss';

import type { SimplePromoProps } from 'app/login/components/SimplePromo';

const bem = bemify('platform-login');

const PlatformLogin = (props: SimplePromoProps) => (
  <SimplePromo
    {...props}
    className={bem()}
    title="Log into your Zapier Account"
  >
    <StaticImage
      alt="Login to platform illustration"
      className={bem('__image')}
      src="/images/partners/login-graphic.svg"
    />
  </SimplePromo>
);

export default PlatformLogin;
